import { postTo } from "src/store/dataService/routes/shared/osfetch";

export interface SoftCreditPullRequestPayload {
    city: string;
    first_name: string;
    last_name: string;
    monthly_income?: number;
    state: string;
    street1: string;
    year_of_birth: string;
    zip: string | null;
}

export interface SoftCreditPullResponseBody {
    score: {
        high: number;
        low: number;
    };
}

export async function postSoftCreditPull(
    uuid: string,
    payload: SoftCreditPullRequestPayload
): Promise<SoftCreditPullResponseBody> {
    const response = await postTo(`/deals/${uuid}/credit/pull/soft`, payload);

    if (!response.ok) {
        throw new Error("Error from Soft Credit Pull");
    }
    return response.json();
}
